import React, { useState, Component } from "react";
import ICONS from "../../../../icons-lib";
import Header from "../includes/header/header";
import "./single-survey-page.scss";

const SingleSurveyPage = () => {

  const [ans1Active, setAns1Active] = useState(false);
  const [ans2Active, setAns2Active] = useState(false);
  const [ans3Active, setAns3Active] = useState(false);
  const [ans4Active, setAns4Active] = useState(false);

  const changeAns = (ansNumber) => {
    switch (ansNumber) {
      case 1:
        setAns1Active(true);
        setAns2Active(false);
        setAns3Active(false);
        setAns4Active(false);
        break;

      case 2:
        setAns1Active(false);
        setAns2Active(true);
        setAns3Active(false);
        setAns4Active(false);
        break;
      
      case 3:
        setAns1Active(false);
        setAns2Active(false);
        setAns3Active(true);
        setAns4Active(false);
        break;

      case 4:
        setAns1Active(false);
        setAns2Active(false);
        setAns3Active(false);
        setAns4Active(true);
        break;
    
      default:
        break;
    }
  }

  return (
    <>
      <Header />
      <div className="single-survey-page-wrapper bg-color_primary_light flex items-center justify-center mt-12 mb-32">
        <div className="container p-8">
          <div className="inner-wrapper grid gap-16 text-left">
            
            <div className="left">
              <div className="text-size-body text-body">Question 1</div>
              <div className="question text-size-heading text-heading my-6">Nulla porttitor accumsan tincidunt. Quisque velit nisi, pretium ut lacinia in, elementum id enim.?</div>

              <div className="options grid gap-6">
                <div
                  className={"answer text-size-heading-small rounded-2xl p-8 duration-200 cursor-pointer " + (ans1Active ? "active" : "")}
                  onClick={(e) => changeAns(1)}
                >This is answer 1</div>
                <div
                  className={"answer text-size-heading-small rounded-2xl p-8 duration-200 cursor-pointer " + (ans2Active ? "active" : "")}
                  onClick={(e) => changeAns(2)}
                >This is answer 2</div>
                <div
                  className={"answer text-size-heading-small rounded-2xl p-8 duration-200 cursor-pointer " + (ans3Active ? "active" : "")}
                  onClick={(e) => changeAns(3)}
                >This is answer 3</div>
                <div
                  className={"answer text-size-heading-small rounded-2xl p-8 duration-200 cursor-pointer " + (ans4Active ? "active" : "")}
                  onClick={(e) => changeAns(4)}
                >This is answer 4</div>
              </div>

              <div className="nav flex gap-2 justify-end my-16">
                <div className="prev flex items-center gap-4 cursor-pointer py-2 px-4 hover:bg-gray-200 duration-200 rounded-lg">
                  {ICONS.SVG_Arrow_left} <span className="text-size-body">Previous</span>
                </div>
                <div className="next flex items-center gap-4 cursor-pointer py-2 px-4 hover:bg-gray-200 duration-200 rounded-lg">
                  <span className="text-size-body">Next</span> {ICONS.SVG_Arrow_right}
                </div>
              </div>


              <div className="bottom-action flex items-center justify-between mt-32">
                <div className="button">
                  <span>Leave survey</span>
                  {ICONS.SVG_Arrow_simple}
                </div>
                <div className="button fancy">
                  <span>Submit survey</span>
                  {ICONS.SVG_Arrow_curly}
                </div>
              </div>
            </div>




            <div className="right">
              <div className="text-size-body text-body">Coming up next</div>

              <div className="question-list my-8">
                <div className="question-item grid gap-4 bg-gray-100 text-body hover:bg-secondary-dark cursor-pointer duration-200 text-size-body rounded-lg my-4 p-4 active">
                  <span>1.</span>
                  <span>Nulla porttitor accumsan tincidunt. Quisque velit nisi, pretium ut lacinia in, elementum id enim.?</span>
                </div>
                
                <div className="question-item grid gap-4 bg-gray-100 text-body hover:bg-secondary-dark cursor-pointer duration-200 text-size-body rounded-lg my-4 p-4">
                  <span>2.</span>
                  <span>Nulla porttitor accumsan tincidunt. Quisque velit nisi, pretium ut lacinia in, elementum id enim.?</span>
                </div>

                <div className="question-item grid gap-4 bg-gray-100 text-body hover:bg-secondary-dark cursor-pointer duration-200 text-size-body rounded-lg my-4 p-4">
                  <span>3.</span>
                  <span>Nulla porttitor accumsan tincidunt. Quisque velit nisi, pretium ut lacinia in, elementum id enim.?</span>
                </div>

                <div className="question-item grid gap-4 bg-gray-100 text-body hover:bg-secondary-dark cursor-pointer duration-200 text-size-body rounded-lg my-4 p-4">
                  <span>4.</span>
                  <span>Nulla porttitor accumsan tincidunt. Quisque velit nisi, pretium ut lacinia in, elementum id enim.?</span>
                </div>

                <div className="question-item grid gap-4 bg-gray-100 text-body hover:bg-secondary-dark cursor-pointer duration-200 text-size-body rounded-lg my-4 p-4">
                  <span>5.</span>
                  <span>Nulla porttitor accumsan tincidunt. Quisque velit nisi, pretium ut lacinia in, elementum id enim.?</span>
                </div>

                <div className="question-item grid gap-4 bg-gray-100 text-body hover:bg-secondary-dark cursor-pointer duration-200 text-size-body rounded-lg my-4 p-4">
                  <span>6.</span>
                  <span>Nulla porttitor accumsan tincidunt. Quisque velit nisi, pretium ut lacinia in, elementum id enim.?</span>
                </div>

                <div className="question-item grid gap-4 bg-gray-100 text-body hover:bg-secondary-dark cursor-pointer duration-200 text-size-body rounded-lg my-4 p-4">
                  <span>7.</span>
                  <span>Nulla porttitor accumsan tincidunt. Quisque velit nisi, pretium ut lacinia in, elementum id enim.?</span>
                </div>

                <div className="question-item grid gap-4 bg-gray-100 text-body hover:bg-secondary-dark cursor-pointer duration-200 text-size-body rounded-lg my-4 p-4">
                  <span>8.</span>
                  <span>Nulla porttitor accumsan tincidunt. Quisque velit nisi, pretium ut lacinia in, elementum id enim.?</span>
                </div>

                <div className="question-item grid gap-4 bg-gray-100 text-body hover:bg-secondary-dark cursor-pointer duration-200 text-size-body rounded-lg my-4 p-4">
                  <span>9.</span>
                  <span>Nulla porttitor accumsan tincidunt. Quisque velit nisi, pretium ut lacinia in, elementum id enim.?</span>
                </div>

                <div className="question-item grid gap-4 bg-gray-100 text-body hover:bg-secondary-dark cursor-pointer duration-200 text-size-body rounded-lg my-4 p-4">
                  <span>10.</span>
                  <span>Nulla porttitor accumsan tincidunt. Quisque velit nisi, pretium ut lacinia in, elementum id enim.?</span>
                </div>

                <div className="question-item grid gap-4 bg-gray-100 text-body hover:bg-secondary-dark cursor-pointer duration-200 text-size-body rounded-lg my-4 p-4">
                  <span>11.</span>
                  <span>Nulla porttitor accumsan tincidunt. Quisque velit nisi, pretium ut lacinia in, elementum id enim.?</span>
                </div>

                <div className="question-item grid gap-4 bg-gray-100 text-body hover:bg-secondary-dark cursor-pointer duration-200 text-size-body rounded-lg my-4 p-4">
                  <span>12.</span>
                  <span>Nulla porttitor accumsan tincidunt. Quisque velit nisi, pretium ut lacinia in, elementum id enim.?</span>
                </div>

                <div className="question-item grid gap-4 bg-gray-100 text-body hover:bg-secondary-dark cursor-pointer duration-200 text-size-body rounded-lg my-4 p-4">
                  <span>13</span>
                  <span>Nulla porttitor accumsan tincidunt. Quisque velit nisi, pretium ut lacinia in, elementum id enim.?</span>
                </div>

                <div className="question-item grid gap-4 bg-gray-100 text-body hover:bg-secondary-dark cursor-pointer duration-200 text-size-body rounded-lg my-4 p-4">
                  <span>14.</span>
                  <span>Nulla porttitor accumsan tincidunt. Quisque velit nisi, pretium ut lacinia in, elementum id enim.?</span>
                </div>

                <div className="question-item grid gap-4 bg-gray-100 text-body hover:bg-secondary-dark cursor-pointer duration-200 text-size-body rounded-lg my-4 p-4">
                  <span>15.</span>
                  <span>Nulla porttitor accumsan tincidunt. Quisque velit nisi, pretium ut lacinia in, elementum id enim.?</span>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleSurveyPage;
